module.exports = __webpack_public_path__ + "static/media/start-conversion.f5b00048.jpg";